__turbopack_context__.v({
  "icon": "InlineIconText-module-scss-module__i71F1G__icon",
  "main": "InlineIconText-module-scss-module__i71F1G__main",
  "tail": "InlineIconText-module-scss-module__i71F1G__tail",
});
